var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.13086 5.55973C3.13086 5.11771 3.30645 4.69378 3.61901 4.38122C3.93158 4.06866 4.3555 3.89307 4.79753 3.89307H14.7975C15.2396 3.89307 15.6635 4.06866 15.976 4.38122C16.2886 4.69378 16.4642 5.11771 16.4642 5.55973V15.5597C16.4642 16.0018 16.2886 16.4257 15.976 16.7382C15.6635 17.0508 15.2396 17.2264 14.7975 17.2264H4.79753C4.3555 17.2264 3.93158 17.0508 3.61901 16.7382C3.30645 16.4257 3.13086 16.0018 3.13086 15.5597V5.55973Z",
    stroke: "#111111",
    strokeWidth: 1.41573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1309 2.2262V5.55953",
    stroke: "#111111",
    strokeWidth: 1.41573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.46436 2.2262V5.55953",
    stroke: "#111111",
    strokeWidth: 1.41573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.13086 8.89294H16.4642",
    stroke: "#111111",
    strokeWidth: 1.41573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.46436 12.2262H8.13102V13.8929H6.46436V12.2262Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 1.41573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9a6dea62cf709e5414cce050d66ddde8.svg";
export { ForwardRef as ReactComponent };